// extracted by mini-css-extract-plugin
module.exports = {"ProductPromo":"ProductPromo_ProductPromo__3Xv95","ProductPromoContent":"ProductPromo_ProductPromoContent__1oFve","ProductPromoActions":"ProductPromo_ProductPromoActions__12BCH"};